module.exports = __webpack_public_path__ + "static/media/menu_chat.325462e9.svg";